/**
 * tp-variant-cards.js
 * Handles license card selection and icon pack toggle
 * for the custom variant picker UI.
 *
 * Uses document-level event delegation so handlers
 * survive DOM replacement by product-info.js.
 */
(function() {
  document.addEventListener('click', function(e) {

    /* License card click — toggle active class */
    var card = e.target.closest('[data-tp-license-card]');
    if (card) {
      var grid = card.closest('.tp-license-grid');
      if (grid) {
        grid.querySelectorAll('[data-tp-license-card]').forEach(function(c) {
          c.classList.remove('active');
        });
        card.classList.add('active');
      }
      return;
    }

    /* Icon pack row toggle */
    var iconRow = e.target.closest('[data-tp-icon-row]');
    if (iconRow) {
      e.preventDefault();

      var isActive = iconRow.classList.contains('active');
      var noRadio = iconRow.querySelector('input[value="No Illustration Pack"]');
      var yesRadio = iconRow.querySelector('input[value="Illustration Pack"]');

      if (isActive) {
        iconRow.classList.remove('active');
        if (noRadio) {
          noRadio.checked = true;
          noRadio.dispatchEvent(new Event('change', { bubbles: true }));
        }
      } else {
        iconRow.classList.add('active');
        if (yesRadio) {
          yesRadio.checked = true;
          yesRadio.dispatchEvent(new Event('change', { bubbles: true }));
        }
      }
    }
  });
})();